export default {
  route: {
    dashboard: '首页',
    documentation: '文档',
    guide: '引导页',
    permission: '权限测试页',
    rolePermission: '角色权限',
    pagePermission: '页面权限',
    directivePermission: '指令权限',
    icons: '图标',
    components: '组件',
    componentMixin: '小组件',
    backToTop: '返回顶部',
    errorPages: '错误页面',
    page401: '401',
    page404: '404',
    errorLog: '错误日志',
    selectIndustry: '选择行业',
    profile: '个人中心',
    goods: '商品',
    goodsManage: '商品管理',
    goodsAdd: '添加商品',
    goodsEdit: '编辑商品',
    goodsCategory: '商品分类',
    goodsComment: '商品评价',
    goodsCommentDetail: '评论详情',
    order: '订单',
    orderManage: '订单管理',
    orderDetail: '订单详情',
    orderRefund: '售后管理',
    orderRefundDetail: '售后详情',
    plateRefund: '平台售后',
    plateRefundDetail: '售后详情',
    user: '会员',
    userManage: '会员管理',
    userGrade: '等级管理',
    userTag: '标签管理',
    userPoints: '积分管理',
    userBalance: '余额明细',
    data: '统计',
    dataSales: '销售统计',
    dataUser: '会员统计',
    dataPurveyor: '商户统计',
    dataAccess: '访问统计',
    finance: '财务',
    financeInfo: '财务概况',
    financeSettled: '店铺结算',
    financeOrder: '订单结算',
    app: '应用',
    appSetting: '基础设置',
    appWx: '小程序',
    appMp: '公众号',
    appOpen: 'app',
    appH5: 'h5',
    setting: '设置',
    settingStore: '商城设置',
    settingTrade: '交易设置',
    settingDelivery: '运费模板',
    settingExpress: '物流公司',
    settingMessage: '消息设置',
    settingSms: '短信设置',
    settingProtocol: '协议设置',
    settingStorage: '上传设置',
    settingClear: '清理缓存',
    settingPrinter: '打印机管理',
    settingPrinting: '打印设置',
    settingAddress: '退货地址',
    authority: '权限',
    authorityUser: '管理员列表',
    authorityRole: '角色管理',
    authorityLoginLog: '登录日志',
    authorityOptLog: '操作日志',
    home: '店铺',
    homeEdit: '首页编辑',
    homePage: '页面列表',
    homeCategory: '分类模板',
    homeNav: '底部导航',
    homeMenu: '底部菜单',
    homeMyMenu: '我的菜单'
  },
  navbar: {
    dashboard: '首页',
    github: '项目地址',
    logOut: '退出登录',
    profile: '个人中心',
    updatePassword: '修改密码',
    theme: '换肤',
    size: '布局大小'
  },
  login: {
    title: '系统登录',
    logIn: '登录',
    username: '账号',
    password: '密码',
    any: '随便填',
    thirdparty: '第三方登录',
    thirdpartyTips: '本地不能模拟，请结合自己业务进行模拟！！！'
  },
  documentation: {
    documentation: '文档',
    github: 'Github 地址'
  },
  permission: {
    addRole: '新增角色',
    editPermission: '编辑权限',
    roles: '你的权限',
    switchRoles: '切换权限',
    tips: '在某些情况下，不适合使用 v-permission。例如：Element-UI 的 el-tab 或 el-table-column 以及其它动态渲染 dom 的场景。你只能通过手动设置 v-if 来实现。',
    delete: '删除',
    confirm: '确定',
    cancel: '取消'
  },
  guide: {
    description: '引导页对于一些第一次进入项目的人很有用，你可以简单介绍下项目的功能。本 Demo 是基于',
    button: '打开引导'
  },
  components: {
    documentation: '文档',
    tinymceTips: '富文本是管理后台一个核心的功能，但同时又是一个有很多坑的地方。在选择富文本的过程中我也走了不少的弯路，市面上常见的富文本都基本用过了，最终权衡了一下选择了Tinymce。更详细的富文本比较和介绍见',
    dropzoneTips: '由于我司业务有特殊需求，而且要传七牛 所以没用第三方，选择了自己封装。代码非常的简单，具体代码你可以在这里看到 @/components/Dropzone',
    stickyTips: '当页面滚动到预设的位置会吸附在顶部',
    backToTopTips1: '页面滚动到指定位置会在右下角出现返回顶部按钮',
    backToTopTips2: '可自定义按钮的样式、show/hide、出现的高度、返回的位置 如需文字提示，可在外部使用Element的el-tooltip元素',
    imageUploadTips: '由于我在使用时它只有vue@1版本，而且和mockjs不兼容，所以自己改造了一下，如果大家要使用的话，优先还是使用官方版本。'
  },
  table: {
    dynamicTips1: '固定表头, 按照表头顺序排序',
    dynamicTips2: '不固定表头, 按照点击顺序排序',
    dragTips1: '默认顺序',
    dragTips2: '拖拽后顺序',
    title: '标题',
    importance: '重要性',
    type: '类型',
    remark: '点评',
    search: '搜索',
    add: '添加',
    export: '导出',
    reviewer: '审核人',
    id: '序号',
    date: '时间',
    author: '作者',
    readings: '阅读数',
    status: '状态',
    actions: '操作',
    edit: '编辑',
    publish: '发布',
    draft: '草稿',
    delete: '删除',
    cancel: '取 消',
    confirm: '确 定'
  },
  example: {
    warning: '创建和编辑页面是不能被 keep-alive 缓存的，因为keep-alive 的 include 目前不支持根据路由来缓存，所以目前都是基于 component name 来进行缓存的。如果你想类似的实现缓存效果，可以使用 localStorage 等浏览器缓存方案。或者不要使用 keep-alive 的 include，直接缓存所有页面。详情见'
  },
  errorLog: {
    tips: '请点击右上角bug小图标',
    description: '现在的管理后台基本都是spa的形式了，它增强了用户体验，但同时也会增加页面出问题的可能性，可能一个小小的疏忽就导致整个页面的死锁。好在 Vue 官网提供了一个方法来捕获处理异常，你可以在其中进行错误处理或者异常上报。',
    documentation: '文档介绍'
  },
  excel: {
    export: '导出',
    selectedExport: '导出已选择项',
    placeholder: '请输入文件名(默认excel-list)'
  },
  zip: {
    export: '导出',
    placeholder: '请输入文件名(默认file)'
  },
  pdf: {
    tips: '这里使用   window.print() 来实现下载pdf的功能'
  },
  theme: {
    change: '换肤',
    documentation: '换肤文档',
    tips: 'Tips: 它区别于 navbar 上的 theme-pick, 是两种不同的换肤方法，各自有不同的应用场景，具体请参考文档。'
  },
  tagsView: {
    refresh: '刷新',
    close: '关闭',
    closeOthers: '关闭其它',
    closeAll: '关闭所有'
  },
  settings: {
    title: '系统布局配置',
    theme: '主题色',
    tagsView: '开启 Tags-View',
    fixedHeader: '固定 Header',
    sidebarLogo: '侧边栏 Logo'
  },
  msg: {
    success: '操作成功',
    error: '操作失败',
    connectSuccess: '连接成功',
    uploadSuccess: '上传成功',
    uploadError: '上传失败',
    addSuccess: '添加成功',
    addError: '添加失败',
    saveSuccess: '保存成功',
    saveError: '保存失败',
    loadingError: '获取信息失败,请点击重新尝试',
    selectUser: '请选择会员',
    selectServer: '请选择服务者',
    selectOrganization: '请选择组织',
    operateDisable: '操作禁用',
    selectAnnounce: '请选择公告',
    selectRule: '请选择制度',
    selectSlideshow: '请选择幻灯片',
    enterReason: '请输入拒绝原因',
    selectServiceType: '请选择服务分类',
    selectServiceTag: '请选择服务标签',
    selectServiceItem: '请选择服务项目',
    selectDemand: '请选择个人服务',
    selectMultipleItem: '请选择多人项目',
    selectApplyRecord: '请选择报名记录',
    selectCommentLevel: '请选择评分等级',
    selectComment: '请选择评价',
    selectOrder: '请选择订单',
    selectServiceShow: '请选择服务秀',
    selectLevel: '请选择服务等级',
    selectLevelPower: '请选择等级权重',
    selectLevelName: '请填写等级名称',
    selectLevelTime: '请填写TIME兑换比',
    selectSpecValue: '请添加多规格信息',
    selectExchangeGood: '请选择兑换商品',
    selectGoods: '请选择商品',
    refundTotalTime: '退回TIME不能大于实付TIME',
    refundTotalPrice: '退回金额不能大于实付金额',
    selectFaceData: '请选择人脸数据',
    selectPassage: '请选择通道',
    selectServerId: '请选择服务',
    selectCard: '请选择卡项',
    selectCardClass: '请选择卡项分类',
    selectEquipment: '请选择设备',
    selectCityModulus: '请选择城市系数',
    fillCityModulus: '请填写城市系数',
    selectActivity: '请选择活动',
    selectSignNumber: '请选择签到号',
    selectTrade: '请选择行业',
    selectBenefit: '请选择权益'
  },
  page: {
    add: '添加',
    edit: '编辑',
    detail: '详情',
    view: '查看',
    del: '删除',
    search: '查询',
    reset: '重置',
    verify: '审核',
    submit: '提交',
    sure: '确定',
    save: '保存',
    cancel: '取消',
    export: '导出',
    back: '返回',
    tip: '提示',
    refresh: '刷新',
    close: '关闭',
    conceal: '隐藏',
    show: '显示',
    modify: '修改',
    pass: '通过',
    agree: '同意',
    refuse: '拒绝',
    enable: '启用',
    disable: '禁用',
    stop: '停用',
    recover: '恢复',
    moveOut: '移出',
    onShelf: '上架',
    offShelf: '下架',
    dispatch: '派单',
    storage: '暂存',
    nextStep: '下一步',
    prevStep: '上一步',
    release: '发布',
    refund: '退款',
    ship: '发货',
    signup: '签到',
    signout: '签出',
    statistics: '统计',
    selectAll: '当页全选',
    batchEnable: '批量启用',
    batchDisable: '批量禁用',
    batchRecover: '批量恢复',
    batchPass: '批量通过',
    batchRefuse: '批量拒绝',
    batchDel: '批量删除',
    reedit: '重新编辑',
    passAgain: '重新通过',
    verifyActivity: '签到',
    viewDetail: '查看详情',
    viewInfo: '查看信息',
    evaluate: '评价',
    viewEvaluate: '查看评价',
    addServer: '添加服务者',
    addServiceItem: '添加服务项目',
    addService: '添加服务',
    addCard: '添加卡项',
    addTag: '添加标签',
    addOrganization: '添加组织',
    backList: '返回列表',
    selectUser: '选择会员',
    selectGood: '选择商品',
    selectServer: '选择服务者',
    selectService: '选择服务',
    memberManage: '成员管理',
    viewMember: '查看成员',
    addAnnounce: '新建公告',
    addRule: '新建制度',
    showAnnounce: '公示',
    cancelAnnounce: '取消公示',
    addSlideshow: '添加幻灯片',
    addCategory: '添加分类',
    confirmShip: '确认发货',
    confirmReceipt: '确认收货',
    confirmAdd: '确认添加',
    confirmModify: '确定修改',
    confirmReceive: '确定领取',
    confirmVerify: '确认审核',
    saveEdit: '保存修改',
    addDemand: '新建个人服务',
    cancelDemand: '取消服务',
    selectServiceItem: '选择服务项目',
    addMultipleItem: '新建多人项目',
    promote: '推广',
    signCode: '签到码',
    applyRecord: '报名记录',
    viewAllEvaluate: '查看所有评价',
    manualApply: '人工报名',
    remark: '备注',
    addRemark: '添加备注',
    modifyRemark: '修改备注',
    adjustTime: '调整时间酬劳',
    closeOrder: '关闭订单',
    confirmComplete: '确认完成',
    addServiceShow: '新建服务秀',
    forbidPublish: '禁止发布',
    allowPublish: '允许发布',
    addLevel: '添加等级',
    editLevel: '编辑服务等级',
    addNorm: '添加规格',
    addExchangeGood: '添加兑换商品',
    modifyLogistics: '修改物流',
    addPassage: '添加通道',
    addCity: '添加城市',
    selectStore: '选择门店',
    addActivity: '添加活动',
    addSouvenir: '领取伴手礼',
    addGroup: '添加活动组',
    addHost: '添加主办方',
    addHostMember: '添加主办人员',
    addProtocol: '新建协议',
    addManuscript: '添加稿件评级',
    downloadFile: '下载附件',
    downloadCert: '下载证书',
    addBrand: '创建品牌',
    addToBrand: '添加品牌',
    addBrandDay: '创建品牌日',
    brandList: '品牌列表',
    confirmSign: '确认报名',
    addDiscount: '添加折扣',
    addGoods: '添加商品',
    addGroupearn: '项目设置',
    bonusRecord: '分红明细',
    editBonus: '修改分红',
    confirmBones: '确认',
    addMaterial: '上传素材',
    publish: '立即发布',
    addElder: '添加长者',
    addElderTag: '加标签',
    addCare: '新增关怀记录',
    addProject: '添加关怀项目',
    addStaff: '添加员工',
    addHealth: '添加记录',
    setType: '设置分类',
    record: '记录',
    redial: '重拨',
    addGoodsGift: '商品关联赠品'
  }
}



// WEBPACK FOOTER //
// ./src/lang/zh.js